import { useState } from "react";
import useAxiosClient from "../../../../hooks/useAxiosClient";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../../../store";
import { toast } from "react-toastify";
import moment from "moment";
import {
  setOpenBeneficiary,
  setRefreshGetAll,
} from "../bloc/beneficiariesSlice";

const useAddBeneficiary = () => {
  const { handlePostCall, handlePutCall } = useAxiosClient();

  const { adminId, refId, addBenefiSteps } = useSelector((state: TRootState) => ({
    adminId: state.auth.adminId,
    refId: state.beneficiary.refId,
    addBenefiSteps: state.beneficiary.addBenefiSteps
  }));

  const dispatch = useDispatch();

  const [otpScreen, setOtpScress] = useState(false);

  const [addBenefi, setAddBenefi] = useState<{
    accHolder: string;
    accNumb: string;
    bankName: string;
    ifscCode: string;
    accountType: string;
    traderType: string;
    mobile: string;
    email: string;
    note1: string;
    note2: string;
  }>({
    accHolder: "",
    accNumb: "",
    bankName: "",
    ifscCode: "",
    accountType: "",
    traderType: "",
    mobile: "",
    email: "",
    note1: "",
    note2: "",
  });

  const [loading, setLoading] = useState(false);
  const [submiOtpStatus, setSubmitOtpStatus] = useState<{
    status: "" | "PENDING" | "COMPLETED" | "LOADING";
  }>({ status: "PENDING" });

  const validateAddPayout = () => {
    if (!addBenefi.accHolder) {
      toast.error("Please enter account holder");
      return false;
    }

    if (!addBenefi.accNumb) {
      toast.error("Please enter account number");
      return false;
    }

    if (addBenefi.accNumb.length < 5) {
      toast.error("Account number should have min 5 characters");
      return false;
    }

    if (addBenefi.accNumb.length > 35) {
      toast.error("Account number should have max 35 characters");
      return false;
    }

    if (!addBenefi.bankName) {
      toast.error("Please enter bank name");
      return false;
    }

    if (!addBenefi.ifscCode) {
      toast.error("Please enter IFSC code");
      return false;
    }

    if (!addBenefi.accountType) {
      toast.error("Please select account type");
      return false;
    }

    if (!addBenefi.mobile) {
      toast.error("Please enter contact number");
      return false;
    }

    if (addBenefi.mobile.length !== 10) {
      toast.error("Please enter 10 digit contact number");
      return false;
    }

    return true;
  };

  const onSubmit = () => {
    setSubmitOtpStatus({ ...submiOtpStatus, status: "LOADING" });
    if (validateAddPayout()) {
      setLoading(true);
      let apiParams = {
        adminId: adminId,
        traderId: 0,
        traderType: addBenefi?.traderType,
        actHolder: addBenefi?.accHolder,
        actNum: addBenefi?.accNumb,
        bankName: addBenefi?.bankName,
        ifsc: addBenefi?.ifscCode,
        actType: addBenefi?.accountType.toUpperCase(),
        contactNum: addBenefi?.mobile,
        email: addBenefi?.email,
        notes: {
          notes_key_1: addBenefi?.note1,
          notes_key_2: addBenefi?.note2,
        },
        type: "TP_BEN",
        userType: addBenefi?.traderType,
        accntType: addBenefi?.accountType
      };
      handlePostCall({
        URL: "payments/payouts/traders/accounts",
        apiParams: apiParams,
      })
        .then(({ data, status }) => {
          toast.success(status.description);
          setSubmitOtpStatus({ ...submiOtpStatus, status: "COMPLETED" });
          dispatch(setOpenBeneficiary(false));
          dispatch(setRefreshGetAll());
        })
        .catch((err: any) => {
          setLoading(false);
          setSubmitOtpStatus({ ...submiOtpStatus, status: "" });
        })
        .finally(() => {
          setLoading(false);
          setSubmitOtpStatus({ ...submiOtpStatus, status: "" });
        });
    }
  };

  return {
    addBenefi,
    setAddBenefi,
    onSubmit,
    otpScreen,
    setOtpScress,
    validateAddPayout,
    refId,
    addBenefiSteps
  };
};
export default useAddBeneficiary;
